var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuBrowseIcon = function SvgMenuBrowseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.055 4.688a8.746 8.746 0 1 0 2.561 6.183 8.718 8.718 0 0 0-2.561-6.183Zm-.961 1.344-3.495 6.449a.226.226 0 0 1-.033.049l-.028.028h-.005l-.006.006a.27.27 0 0 1-.05.033L6.032 16.09a.282.282 0 0 1-.386-.379l3.49-6.441a.3.3 0 0 1 .056-.082.262.262 0 0 1 .082-.056l6.442-3.491a.282.282 0 0 1 .379.386Zm-3.812 5.851L9.859 9.46l5.29-2.866Zm-.4.4-5.289 2.866L9.459 9.86ZM10.872 0a10.873 10.873 0 1 1-7.687 3.185A10.835 10.835 0 0 1 10.872 0Zm7.288 3.583A10.308 10.308 0 1 1 10.872.564a10.273 10.273 0 0 1 7.288 3.019Z",
    fillRule: "evenodd"
  })));
};
export default SvgMenuBrowseIcon;